export default (that) => [
  {
    width: 40,
    align: 'center',
    type: 'seq',
    merge: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_orderBatchNo') || '交货批次号',
    field: 'orderBatchNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    mergeByKey: true,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_identifyNo') || '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_deliveryDate') || '出货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_outBillType') || '出单类型',
    field: 'outBillType',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_dispatchPort') || '发运港口',
    field: 'dispatchPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_form_batch_label_destinationPort') || '目的港口',
    field: 'destinationPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    merge: true,
    showHeaderOverflow: true,
    showOverflow: true
  },
]
